export const environment = {
  production: false,
  apiUrl: 'https://api-erp-dev.metroex.com.br/api/v1/',
  apiUrl2: 'http://localhost:58000/api/v1/',
  clientVersion: '0.0.0'
};


// WEBPACK FOOTER //
// ./src/environments/environment.ts